import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Helmet } from 'react-helmet';
import { TrafficItem } from '../../component/trafficItem';
import {
  getColorByCategory,
  getIconForCategory,
  getTrafficNameByCategory,
} from '../../component/trafficItem/trafficItem';
import { TrafficGoogleMap } from '../../component/trafficGoogleMap';
import { StandardArticle } from './../../../ui/src/component/article';
import { LoadMore } from '../../../ui/src/component/loadMore';
import { fetchTraffic, fetchContentSpaceFeed } from '../../actions.js';
import moment from 'moment';
import cx from 'classnames';
import { getProp } from '../../../ui/src/utilities';

const DSRKE_CSPACE = 'dopravnyservis';

class TrafficList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      region: 'ke',
    };

    this.onLoadMoreArticles = this.onLoadMoreArticles.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.onChangeRegion = this.onChangeRegion.bind(this);
  }

  componentDidMount() {
    TrafficList.init(this.props.dispatch);
  }

  onLoadMore(nextOffset) {
    this.props.dispatch(
      fetchTraffic({
        offset: nextOffset,
        limit: 16,
        category: this.state.categories.join(','),
        region: this.state.region
      }),
    );
  }

  onLoadMoreArticles() {
    this.props.dispatch(
      fetchContentSpaceFeed(DSRKE_CSPACE, 12, this.props.articlesNextOffset, true, {smarttags: `region:${this.state.region.toUpperCase()}`}),
    );
  }

  onChangeRegion(region) {
    this.setState({ region }, () => {
      this.props.dispatch(
        fetchTraffic({ limit: 16, category: this.state.categories.join(','), region: this.state.region}),
      );
      this.props.dispatch(
        fetchContentSpaceFeed(DSRKE_CSPACE, 4, 0, false, {smarttags:`region:${this.state.region.toUpperCase()}`}),
      );
    });
  }

  onChangeCategory(category) {
    let categories = this.state.categories.slice();
    let idx = categories.indexOf(category);
    if (idx !== -1) {
      categories.splice(idx, 1);
    } else {
      categories.push(category);
    }

    this.setState({ categories }, () => {
      this.props.dispatch(
        fetchTraffic({ limit: 16, category: this.state.categories.join(','), region: this.state.region}),
      );
    });
  }

  render() {
    const {region} = this.state;
    const { articles, articlesNextOffset } = this.props;
    const hourAgo = moment().subtract(1, 'hour');
    const threeHourAgo = moment().subtract(3, 'hour');
    const fiveHourAgo = moment().subtract(5, 'hour');
    const mapItems = [];
    const newItems = [];
    const oldItems = {
      '3': [],
      '5': [],
      X: [],
    };
    this.props.ids
      .filter(id => {
        return id in this.props.entities;
      })
      .map(id => {
        if (moment(this.props.entities[id].created_date) >= fiveHourAgo) {
          mapItems.push(this.props.entities[id]);
        }
        if (moment(this.props.entities[id].created_date) >= hourAgo) {
          newItems.push(this.props.entities[id]);
        } else if (
          moment(this.props.entities[id].created_date) >= threeHourAgo
        ) {
          oldItems['3'].push(this.props.entities[id]);
        } else if (
          moment(this.props.entities[id].created_date) >= fiveHourAgo
        ) {
          oldItems['5'].push(this.props.entities[id]);
        } else {
          oldItems['X'].push(this.props.entities[id]);
        }
        return this.props.entities[id];
      });

    return (
      <div className="traffic-list">
        <Helmet>
          <title>Dopravný servis</title>
        </Helmet>
        <div className="bg-alt-light article-header">
          <div className="container">
            <div className="article-header-title clearfix">
              <div className='traffic-header'>
              <h1>Dopravný servis</h1>

                <div className='region-switch'>
                  <button className={region === 'ke' ? 'active': ""} onClick={this.onChangeRegion.bind(this, 'ke')}>
                    Košice / Východ / Liptov
                  </button>
                  <button className={region === 'ba' ? 'active': ""} onClick={this.onChangeRegion.bind(this, 'ba')}>
                    Bratislava
                  </button>
                </div>

                <div className="categories" style={{marginLeft: 'auto', selfAlign: 'center'}}>
                  {['radars', 'patrols', 'accidents', 'restrictions'].map(
                    (category, idx) => {
                      const style = {};
                      const isActive =
                        this.state.categories.includes(category) ||
                        this.state.categories.length === 0;
                      if (isActive) {
                        style['backgroundColor'] = getColorByCategory(category);
                      }
                      return (
                        <a
                          key={idx}
                          href=""
                          className={cx('category', { active: isActive })}
                          onClick={e => {e.preventDefault(); this.onChangeCategory(category)}}
                        >
                          <img src={getIconForCategory(category)} alt=""/>
                          <span style={style}>
                            {getTrafficNameByCategory(category)}
                          </span>
                        </a>
                      );
                    },
                  )}
                </div>
              </div>

              
            </div>
          </div>
        </div>
        {mapItems.length >= 0 && (
          <div
            className="bg-alt-light"
            style={{ width: '100%', height: '400px'}}
          >
            <TrafficGoogleMap
              markers={mapItems.map(item => {
                return item;
              })}
              onClickDetail={id => {
                this.props.dispatch(push(`/dopravny-servis/${id}`));
              }}
              region={region}
            />
          </div>
        )}
        <div className="container">
          <div className="section">
            {articles.length > 0 ? (
              <div>
                <h2 className="h1">Dopravný servis Rádia Košice</h2>
                <div className="row">
                  {articles
                    .map(item => {
                      return (
                        <div key={item._id} className="col-sm-6 col-md-3">
                          <StandardArticle
                            article={item}
                            imgOverride={
                              getProp(item, 'picture.uri', null)
                                ? null
                                : 'https://data.tvkosice.sk/static/dsfeed.jpg'
                            }
                          />
                        </div>
                      );
                    })
                    .slice(0, 16)}
                </div>
              </div>
            ) : null}

            {articlesNextOffset !== null && articles.length < 16 ? (
              <div className="text-center section">
                <LoadMore
                  show={articlesNextOffset !== null}
                  onClick={this.onLoadMoreArticles}
                />
              </div>
            ) : null}

            {newItems.length > 0 && (
              <div>
                <h2 className="h1">Aktuálne</h2>
                <div className="row">
                  {newItems.map(item => {
                    return (
                      <div className="col-sm-6 col-md-3" key={item._id}>
                        <TrafficItem item={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {oldItems['3'].length > 0 && (
              <div>
                <h2 className="h1">Do 3 hodín</h2>
                <div className="row">
                  {oldItems['3'].map(item => {
                    return (
                      <div className="col-sm-6 col-md-3" key={item._id}>
                        <TrafficItem item={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {oldItems['5'].length > 0 && (
              <div>
                <h2 className="h1">Do 5 hodín</h2>
                <div className="row">
                  {oldItems['5'].map(item => {
                    return (
                      <div className="col-sm-6 col-md-3" key={item._id}>
                        <TrafficItem item={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {oldItems['X'].length > 0 && (
              <div>
                <h2 className="h1">Staršie dopravné informácie</h2>
                <div className="row">
                  {oldItems['X'].map(item => {
                    return (
                      <div className="col-sm-6 col-md-3" key={item._id}>
                        <TrafficItem item={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {this.props.nextOffset !== null ? (
              <div className="text-center section">
                <LoadMore
                  show={
                    !this.props.isFetching && this.props.nextOffset !== null
                  }
                  onClick={this.onLoadMore.bind(this, this.props.nextOffset)}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

TrafficList.init = dispatch => {
  return Promise.all([
    dispatch(fetchContentSpaceFeed(DSRKE_CSPACE, 4, 0, false, {smarttags:"region:KE"})),
    dispatch(fetchTraffic({ limit: 16, region: 'ke'})),
  ]);
};

TrafficList.fetchData = ({ store }) => {
  return TrafficList.init(store.dispatch);
};

TrafficList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  ids: PropTypes.array.isRequired,
  nextOffset: PropTypes.number,
  entities: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  articlesIsFetching: PropTypes.bool.isRequired,
  articles: PropTypes.array.isRequired,
  articlesNextOffset: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    entities: state.trafficEntities.byId,
    ids: state.traffic.items,
    nextOffset: state.traffic.nextOffset,
    isFetching: state.traffic.isFetching,
    articlesIsFetching: state.feedArticles.isFetching,
    articles: state.feedArticles.articles,
    articlesNextOffset: state.feedArticles.nextOffset,
  };
};

export default connect(mapStateToProps)(TrafficList);



// WEBPACK FOOTER //
// ./src/app/container/traffic/list.js